import { render, staticRenderFns } from "./LcaProduction.vue?vue&type=template&id=40396007"
import script from "./LcaProduction.vue?vue&type=script&lang=js"
export * from "./LcaProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports